// extracted by mini-css-extract-plugin
export default {"root":"TypographyBase_root__IgRjZ"};